import React, { useEffect, useState } from 'react'
import Table from '../../../../../../common/components/table-manager/v1.1/table';

export default function TasksInfoComponent({ libraryData, tasksDetails }: any) {

    const [
        columnDefs,
        setColumnDefs
    ] = useState({});

    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'LogisticsTaskId', headerName: 'Task Id', sortable: true },
            { field: 'RoutePlanStopId', headerName: 'Stop Id', sortable: true },
            {
                field: 'LogisticsTaskStatusId', headerName: 'Task Status',
                cellRenderer: 'libraryRendererComponent',
                cellRendererParams: {
                    library: libraryData?.result?.LogisticsTaskStatus, isRowColorDecider: false
                },
                sortable: true,
                filter: false
            },
            {
                field: 'LogisticsTaskSubTypeId', headerName: 'TaskType Status',
                cellRenderer: 'libraryRendererComponent',
                cellRendererParams: {
                    library: libraryData?.result?.LogisticsTaskSubType, isRowColorDecider: false
                },
                sortable: true,
                filter: false
            },

            { field: 'CreatedOnUtc', headerName: 'CreatedOn', isDateValueFormat: true },
            { field: 'ModifiedOnUtc', headerName: 'ModifiedOn', isDateValueFormat: true },
        ]);
    }

    useEffect(() => {
        createColumnDefs()

    }, [tasksDetails])
    return (
        <>
            <Table
                columnData={columnDefs}
                rowData={tasksDetails}
                checkboxConfig={{
                    allowMultiSelect: true,
                    defaultSelectedIds: [],
                    isDisabled: false,
                    keyColumn: 'Name',
                }}
                enableFilter={true}
                headingName="" />
        </>
    )
}